import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  you: {
    id: 'studio.bDz3Hi',
    defaultMessage: 'It’s you!',
  },
  changeRoleSuccess: {
    id: 'studio.YZkH4v',
    defaultMessage: 'Successfully changed roles of {name} to {roles}.',
  },
  changeRoleError: {
    id: 'studio.W6wFdh',
    defaultMessage: 'Something went wrong when trying to change this user’s roles.',
  },
  empty: {
    id: 'studio.+RhnH+',
    defaultMessage: 'Empty',
  },
  editProperties: {
    id: 'studio.NLpUeI',
    defaultMessage: 'Edit properties',
  },
  key: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  value: {
    id: 'studio.GufXy5',
    defaultMessage: 'Value',
  },
  properties: {
    id: 'studio.aI80kg',
    defaultMessage: 'Properties',
  },
  editButton: {
    id: 'studio.Oz66hT',
    defaultMessage: 'Update properties',
  },
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  deleteMember: {
    id: 'studio.7EMBrV',
    defaultMessage: 'Delete member',
  },
  deleteConfirmationBody: {
    id: 'studio.Jh0bQl',
    defaultMessage: 'Are you sure you want to remove {member} from this app?',
  },
  deleteSuccess: {
    id: 'studio.RBzBwp',
    defaultMessage: '{member} was successfully removed from the app',
  },
});
